<template>
  <div class="question-content">
    <div class="inner-header">
      <span class="type-name">{{questionTitle}}
        <el-button v-if="isApplicationQuestion" type="primary" style="margin-left: 16px" size="mini" @click="openQuestionBackgroundModal">题目背景</el-button>
      </span>
    </div>
    <div class="scroll-box">
      <div class="question-desc question-render-container"></div>
      <div class="question-wrap" v-if="!refreshDom">
        <div class="blank-wrap" v-if="question.typeId === 20">
          <input
            type="text"
            placeholder="请在这里输入答案"
            class="blank-fill"
            v-model="currentAnswer"
            :class="{ 'is-correct-input': isCorrect, 'is-error-input': !isCorrect }"
          >
          <div class="flag">
            <i v-if="isCorrect" class="icon-correct"></i>
            <i v-if="!isCorrect && currentAnswer" class="icon-error"></i>
          </div>
          <span
            class="no-answer"
            v-if="!currentAnswer"
          >未作答</span>
        </div>
        <ul class="option-wrap" v-if="question.typeId === 1">
          <li class="option"
              v-for="(option, index) in question.choice.choices"
              :key="index"
              :class="{
                'is-correct-input': option.submit_id === correctAnswer,
                'is-error-input': option.submit_id === currentAnswer && !isCorrect
              }">
            <div class="option-name-wrap">
              <span>{{order[index]}}</span>
            </div>
            <div class="option-content">
              <p class="desc" v-html="$xss(option.text)" v-if="option.text"></p>
              <img :src="option.image" alt="" class="image">
            </div>
            <div class="flag">
               <i v-if="option.submit_id === correctAnswer && currentAnswer" class="icon-correct"></i>
               <i v-if="option.submit_id === currentAnswer && !isCorrect" class="icon-error"></i>
            </div>
            <span
              class="no-answer"
              v-if="option.submit_id === correctAnswer && !currentAnswer"
            >未作答</span>
          </li>
        </ul>
        <ul class="option-wrap" v-if="question.typeId === 2">
          <li class="option"
              v-for="(option, index) in question.choice.choices"
              :key="index"
              :class="{
                'is-correct-input': correctAnswer.indexOf(option.submit_id) !== -1,
                'is-error-input': currentAnswer.indexOf(option.submit_id) !== -1 && correctAnswer.indexOf(option.submit_id) === -1
              }"
          >
            <div class="option-name-wrap">
              <span>{{order[index]}}</span>
            </div>
            <div class="option-content">
              <p class="desc" v-html="$xss(option.text)" v-if="option.text"></p>
              <img :src="option.image" alt="" class="image">
            </div>
            <div class="flag">
              <i v-if="correctAnswer.indexOf(option.submit_id) !== -1 && currentAnswer.length > 0" class="icon-correct"></i>
              <i
                v-if="currentAnswer.indexOf(option.submit_id) !== -1 && correctAnswer.indexOf(option.submit_id) === -1"
                class="icon-error"
              ></i>
            </div>
            <span
              class="no-answer"
              v-if="correctAnswer.indexOf(option.submit_id) !== -1 && !currentAnswer.length"
            >未作答</span>
          </li>
        </ul>
        <div class="tool-wrap" v-if="isOperateQuestion">
          <iframe v-show="question.questionType !== EnumQuestionType.KittenN" :src="toolUrl" ref="editor" class="editor" :class="{'full-screen': editorFullScreen}" allow="microphone;camera;midi;encrypted-media;usb;"></iframe>
          <div v-show="question.questionType === EnumQuestionType.KittenN" ref="kittenN" class="editor kitten-n" :class="{'full-screen': editorFullScreen}"></div>
          <div class="full-screen-btn" v-show="editorFullScreen">
            <button
              v-if="isCppRealTimeOJ || isPythonRealTimeOJ"
              class="submit-oj-btn"
              @click="handleShowOjRealTimeResult"
            >
                查看结果
            </button>
            <button class="title-tip" @click="showDetail = !showDetail">
              <span class="tip" :class="{ show: showDetail }" @click.stop>
                <i class="icon-close" @click.stop="showDetail = false"></i>
                <el-tabs v-if="isApplicationQuestion" v-model="activeTab" type="card">
                  <el-tab-pane label="题目要求" name="content">
                    <div class="question-render-container"></div>
                  </el-tab-pane>
                  <el-tab-pane label="题目背景" name="background">
                    <div v-html="questionBackground"></div>
                  </el-tab-pane>
                </el-tabs>
                <div v-else class="question-render-container" style="height: 100%; overflow: auto;"></div>
              </span>
            </button>
            <button class="out-full-screen" @click="outFullScreen" v-show="editorFullScreen"></button>
          </div>
          <div class="toAnswer" @click="showFullScreen">全屏查看<span class="arrow"></span></div>
          <div class="mask"></div>
        </div>
        <!--python新题型-->
        <div class="new-type-wrap" v-if="question.questionType === 1">
          <button class="data-download" @click="downloadExamData(question.uploadUrl)"><i class="download-icon"></i>考试资料下载</button>
          <div class="upload-wrap">
            <p class="tip">请根据题目提示，打开海龟编辑器进行作答，作答完成根据要求上传答案</p>
            <div class="answer-wrap" v-if="currentAnswer">
              <i class="python-icon"></i>
              <div class="answer-info">
                <p class="file-name">{{currentAnswer.split('/')[currentAnswer.split('/').length - 1]}}</p>
                <p class="upload-time">{{currentAnswer.split('/')[currentAnswer.split('/').length - 2] | date('Y-m-d H:i')}} 上传成功</p>
              </div>
              <span class="change-btn" @click="downloadExamData(currentAnswer)">查看作品</span>
            </div>
            <p v-else style="font-size: 14px; color: #999">考生未上传答案</p>
          </div>
        </div>
        <ul class="option-wrap" v-if="question.typeId === 6">
          <li class="option"
              v-for="(option, index) in judgeList"
              :key="index"
              :class="{
                'is-correct-input': option.value === correctAnswer,
                'is-error-input': option.value === currentAnswer && !isCorrect
              }"
          >
            <div class="option-name-wrap">
              <span>{{order[index]}}</span>
            </div>
            <div class="option-content">
              <p class="desc">{{option.name}}</p>
            </div>
            <div class="flag">
              <i v-if="option.value === correctAnswer && currentAnswer" class="icon-correct"></i>
              <i v-if="option.value === currentAnswer && !isCorrect" class="icon-error"></i>
            </div>
            <span class="no-answer" v-if="option.value === correctAnswer && !currentAnswer">未作答</span>
          </li>
        </ul>
      </div>
      <div class="answer-wrap">
        <p>
          本题得分：
          <span v-if="question.typeId === 10">
            {{ question.normal ? '自动判分失败' : question.score }}
          </span>
          <span v-else-if="question.typeId === 11">待批改</span>
          <span v-else>{{ question.score }}</span>
        </p>
        <div v-if="question.typeId === 1">
          <p>正确答案：{{ order[correctAnswer-1] }}</p>
          <p>你的答案：{{ !currentAnswer ? '未作答' : order[currentAnswer-1] }}</p>
        </div>
        <div v-if="question.typeId === 2">
          <p>正确答案：
            <span v-for="item in correctAnswer" :key="item+'correctAnswer'">{{ order[item-1] }}</span>
          </p>
          <p>你的答案：
            <span v-if="!currentAnswer.length">未作答</span>
            <template v-else>
              <span v-for="item in currentAnswer" :key="item+'correctAnswer2'">{{ order[item-1] }}</span>
            </template>
          </p>
        </div>
        <div v-if="question.typeId === 6">
          <p>正确答案：
            {{ order[correctAnswer-1] }}
          </p>
          <p>你的答案：
            {{ !currentAnswer ? '未作答' : order[currentAnswer-1] }}
          </p>
        </div>
        <div v-if="question.typeId === 10">
          <p>测试数据：
            <span v-if="!correctAnswer">暂无参考数据</span>
            <el-table
              v-else
              :data="correctAnswer"
              style="width: 400px; margin: 10px 0;"
              border
            >
              <el-table-column
                prop="input"
                label="输入">
              </el-table-column>
              <el-table-column
                prop="output"
                label="输出">
              </el-table-column>
            </el-table>
          </p>
          <!--<p>你的答案：-->
            <!--<span v-html="currentAnswer"></span>-->
          <!--</p>-->
        </div>
        <div v-if="question.typeId === 11">
          <p>参考答案：
            <span v-if="!correctAnswer">无</span>
            <a v-else :href="correctAnswer" class=link-color>{{ question.kitten.answer_bcm.filename }}</a>
          </p>
          <!--<p>你的答案：-->
            <!--<a :href="currentAnswer" class=link-color>{{ question.kitten.answer_bcm.filename }}</a>-->
          <!--</p>-->
        </div>
        <div v-if="question.typeId === 20">
          <p>正确答案：{{ correctAnswer }}</p>
          <p>你的答案：{{ !currentAnswer ? '未作答' : currentAnswer }}</p>
        </div>
        <p>【题目解析】<span v-html="$xss(question.analysis)"></span></p>
      </div>
    </div>
    <div class="btn-wrap">
      <a
        @click="prevQuestion"
        :style="`color: ${$store.state.theme.themeColor} border: 1px solid ${$store.state.theme.themeColor}`"
        v-if="!isFirst"
        class="prev-btn">上一题</a>
      <a
        type="primary"
        :style="`background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`"
        @click="nextQuestion"
        v-if="!isLast" class="next-btn">下一题</a>
    </div>
     <OJResultModal
      ref="ojResultModal"
      @downloadCode="handleDownloadCode"
    />
    <Modal
      :show="showQuestionBackground"
      @update:show="showQuestionBackground = false"
      title="题目背景"
    >
      <div slot="content" v-html="questionBackground"></div>
    </Modal>
  </div>
</template>

<script>
import 'element-ui/packages/theme-chalk/src/radio.scss'
import { downloadData, getExamId } from '@/utils'
import { get } from '@/utils/ajax'
import QuestionContentMixin from '@/mixins/QuestionContentMixin'
import { EnumQuestionType, Enum3DBoxType, EnumTypeId, isOperateQuestion, initKittenN, get3DBoxInfo } from '../Test/pc/handler'

import OJResultModal from '../Test/pc/OJResultModal.vue'
import { getLastOjRealtimeCode, getLastOjRealtimeResult } from '@/apis/ojRealtime.api'
import Modal from '@/components/Modal'
import { Table, TableColumn, Button, Tabs, TabPane } from 'element-ui'
import { formateQuesType } from '@/utils/common'
import { getWood2CatBitPayload } from '@/utils/operation-question'

export default {
  mixins: [QuestionContentMixin],
  components: {
    OJResultModal,
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  props: {
    question: {
      type: Object,
      default () {
        return {}
      }
    },
    questionList: {
      type: Array,
      default() {
        return []
      }
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    isMaking: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      order: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
      currentAnswer: '',
      correctAnswer: '',
      isCorrect: false,
      toolUrl: '',
      editorFullScreen: false,
      refreshDom: false,
      EnumQuestionType,
      showQuestionBackground: false,
      showDetail: false,
      activeTab: 'content',
      judgeList: [
        {
          value: 1,
          name: '对'
        },
        {
          value: 2,
          name: '错'
        }
      ],
      blankBcm: 'https://public-static-edu.codemao.cn/eduexam/blank.bcm',
      box3dWorkId: '', // 3D box 作品 ID
      knSdk: null, // Kitten·N SDK 实例
      knIniting: false, // Kitten·N 初始化状态
      operateIds: ['kitten', '', 'python', 'scratch', '', 'explore', 'cplusplus', 'python_oj', 'box3d', 'kitten_n', 'python_real_time_oj', 'cplusplus_real_time_oj', 'wood2_cloud']
    }
  },
  mounted () {
    this.$nextTick(
      this.toolListener()
    )
  },
  computed: {
    isCppRealTimeOJ() {
      return this.question.questionType === EnumQuestionType.CplusplusRealTimeOJ
    },
    isPythonRealTimeOJ() {
      return this.question.questionType === EnumQuestionType.PythonRealTimeOJ
    },
    isApplicationQuestion() {
      const question = this.questionList.find(item => item.questionId === this.question.questionId)
      if (!question) {
        return false
      }
      console.log(question)
      return question.suiteType === 1
    },
    questionBackground() {
      const question = this.questionList.find(item => item.questionId === this.question.questionId)
      if (!question || question.suiteType !== 1) {
        return ''
      }
      return question.suiteContent
    },
    questionTitle() {
      const question = this.questionList.find(item => item.questionId === this.question.questionId)
      if (!question) {
        return ''
      }
      if (question.suiteType === 1) {
        const suiteId = question.suiteId
        const suiteIdList = this.questionList.filter(item => item.suiteType === 1).map(item => item.suiteId).filter((item, index, self) => self.indexOf(item) === index)
        return `应用题 ${suiteIdList.indexOf(suiteId) + 1}`
      }
      return this.formateType(question.typeId, question.questionType)
    },
    isOperateQuestion() {
      return isOperateQuestion(this.question.questionType)
    },
    isCatbitQuestion() {
      return this.question.questionType === EnumQuestionType.Wood2Cloud && // wood2云模式的题目
        !!this.question.operation.start_work // 存在预置文件
    }
  },
  watch: {
    showDetail (val) {
      if (val) {
        this.$nextTick(() => {
          this.renderRawDescription(this.question.rawDescription)
        })
      }
    },
    question: {
      handler: function (val) {
        this.refreshDom = true
        this.currentAnswer = val.typeId === 2 ? [] : ''
        this.correctAnswer = val.typeId === 2 ? [] : ''
        if (val.answer) {
          switch (val.typeId) {
            case 1:
            case 6:
              this.currentAnswer = Number(val.answer)
              break
            case 2:
              val.answer.forEach((t, i) => {
                val.answer[i] = Number(t)
              })
              this.currentAnswer = val.answer.sort()
              break
            case EnumTypeId.KittenN:
              this.currentAnswer = JSON.parse(val.answer)
              break
            default:
              this.currentAnswer = val.answer
          }
        }
        switch (val.typeId) {
          case 1:
            this.correctAnswer = Number(val.choice.answer[0])
            break
          case 2:
            val.choice.answer.forEach((t, i) => {
              val.choice.answer[i] = Number(t)
            })
            this.correctAnswer = val.choice.answer.sort()
            break
          case 20:
            this.correctAnswer = val.blank.answer
            break
          case 6:
            this.correctAnswer = val.yesNo.answer
            break
          case 11:
            if (this.question.questionType === 0) {
              this.correctAnswer = val.kitten.answer_bcm.url
            }
            break
          case 10:
            this.correctAnswer = val.operation.test_datas
            break
        }
        // 渲染题目
        this.renderRawDescription(val.rawDescription)
        this.isCorrect = val.score !== 0
        if ([
          EnumQuestionType.Kitten,
          EnumQuestionType.Python,
          EnumQuestionType.Scratch,
          EnumQuestionType.Wood2Cloud,
          EnumQuestionType.Cplusplus,
          EnumQuestionType.PythonOJ,
          EnumQuestionType.CplusplusRealTimeOJ,
          EnumQuestionType.PythonRealTimeOJ,
          EnumQuestionType.Box3D
        ].includes(val.questionType)) {
          this.urlEncode()
        } else if (val.questionType === EnumQuestionType.KittenN) {
          this.initKittenN()
        }
        setTimeout(() => {
          this.refreshDom = false
        }, 100)
      },
      deep: false,
      immediate: true
    }
  },
  methods: {
    // 下载考试资料
    downloadExamData (url) {
      downloadData(url)
    },
    toolListener () {
      window.addEventListener('message', e => {
        const message = e.data
        switch (message.msg) {
          case 'wood_is_ready':
            this.initPython()
            break
        }
        switch (message.type) {
          case 'IFRAME_READY':
            this.loadOperateWork()
            break
          case 'kitten_loaded':
            this.initKitten()
            this.loadKittenWork()
            if (this.question.kittenMaterialLoad === 1) { // 打开素材库
              this.$refs.editor.contentWindow.postMessage( // 展示素材库  注意：kitten@3.7.0版本后，素材库material_dialog配置为bool值
                { type: 'kitten_set_ui', content: { sprite_panel: { material_dialog: 'default' } } }, CONFIG.ide
              )
            }
            break
        }
      })
    },
    async loadOperateWork() {
      const { questionType } = this.question
      const code = this.currentAnswer
      let exportName = ''
      switch (questionType) {
        case EnumQuestionType.Cplusplus:
        case EnumQuestionType.CplusplusRealTimeOJ:
        case EnumQuestionType.PythonOJ:
        case EnumQuestionType.PythonRealTimeOJ: {
          let ext, domain
          if (questionType === EnumQuestionType.Cplusplus || questionType === EnumQuestionType.CplusplusRealTimeOJ) {
            ext = 'cpp'
            domain = CONFIG.cplusplus
            exportName = 'exportAsCppFile'
          } else {
            ext = 'py'
            domain = CONFIG.python_oj
            exportName = 'exportAsPythonFile'
          }
          this.$refs.editor.contentWindow.postMessage(
            {
              type: 'FEATURE_SET_CONFIG',
              payload: {
                headerDisabled: false, // 默认展示头部栏，true 则隐藏
                headerLogoDisabled: true, // 默认展示头部栏中的Logo，true 则隐藏
                headerFileMenuDisabled: false, // 默认展示头部栏中的文件菜单，true 则隐藏
                headerFileMenuItems: [
                  exportName
                ], // 默认展示所有头部栏文件菜单选项，[] 则隐藏所有
                userAvatarDisabled: true, // 默认展示用户头像，true 则隐藏
                workSaveButtonDisabled: true, // 默认展示作品保存按钮，true 则隐藏
                workNameInputDisabled: true, // 默认展示作品名称输入框，true 则隐藏
                disabledRegExp: true // 默认隐藏正则配置，false 则展示
              }
            }, domain)
          this.$refs.editor.contentWindow.postMessage({
            type: 'WORK_OPEN',
            payload: {
              work: {
                work_id: 0,
                name: '作品',
                extension: ext,
                content: code,
                version: 0
              }
            }
          }, domain)
          break
        }
        case EnumQuestionType.Wood2Cloud: {
          this.$refs.editor.contentWindow.postMessage({
            type: 'RESET_EDITOR_STATUS'
          }, CONFIG.wood2_cloud)

          let wood2CloudPayload = {
            work_id: 0,
            work_name: '新的作品',
            content: [{
              work_id: 0,
              file_id: -49,
              file_name: 'main.py',
              source: code,
              open: true,
              pid: 0,
              file_type: 2
            }],
            update_time: new Date().getTime(),
            language_type: 3
          }
          if (this.isCatbitQuestion) {
            // 如果答案不存在，则获取预置文件
            if (!this.currentAnswer) {
              const presetPayload = await getWood2CatBitPayload(this.question.operation.start_work)
              if (presetPayload) {
                wood2CloudPayload = presetPayload
              }
            } else {
              // 小猫板的题目，答案是JSON字符串，需要解析成对象
              try {
                wood2CloudPayload = JSON.parse(this.currentAnswer)
              } catch (e) {
                // 解析失败
                console.error('解析预置文件失败', e)
              }
            }
          }
          this.$refs.editor.contentWindow.postMessage({
            type: 'SET_CURRENT_WOOD_PROJECT',
            payload: wood2CloudPayload
          }, CONFIG.wood2_cloud)

          break
        }
        case EnumQuestionType.Box3D: {
          const info = await this.fetch3DBoxInfo()
          const editUrl = info.url
          this.$refs.editor.src = editUrl
          break
        }
      }
    },
    async loadKittenWork() {
      const answer = this.currentAnswer
      let bcmUrl
      if (this.isMaking) {
        if (answer) {
          if (typeof answer === 'string') {
            const { bcm_url } = await get(`/edu/exams/works/kitten?code=${answer}`)
            bcmUrl = bcm_url
          } else {
            bcmUrl = answer.url
          }
        }
      } else {
        bcmUrl = this.question.kitten.start_bcm.url
      }
      this.$refs.editor.contentWindow.postMessage({ type: 'load_bcm', content: bcmUrl }, window.CONFIG.ide)
    },
    initKitten() { // 初始化kitten配置项
      const kitten = this.$refs.editor
      kitten.contentWindow.postMessage( // 展示文件按钮
        { type: 'kitten_set_ui', content: { header: { file: true } } }, CONFIG.ide
      )
      kitten.contentWindow.postMessage( // 展示保存作品到本地
        { type: 'kitten_set_ui', content: { header: { export_file: true } } }, CONFIG.ide
      )
      kitten.contentWindow.postMessage( // 展示设置按钮
        { type: 'kitten_set_ui', content: { header: { setting: true } } }, CONFIG.ide
      )
      kitten.contentWindow.postMessage( // 展示语言切换
        { type: 'kitten_set_ui', content: { header: { language: true } } }, CONFIG.ide
      )
    },
    initPython () {
      // 设为代码模式
      setTimeout(() => {
        this.$refs.editor.contentWindow.postMessage(
          { msg: 'set_default_mode', mode: 'code' }, CONFIG.python
        )
      }, 100)
      setTimeout(() => {
        this.$refs.editor.contentWindow.postMessage(
          { msg: 'set_mode_btn_display', mode: 'false' }, CONFIG.python
        )
      }, 100)
      // 隐藏自带的缩放按钮
      setTimeout(() => {
        this.$refs.editor.contentWindow.postMessage(
          { msg: 'set_fullscreen_btn_display', is_display: false }, CONFIG.python
        )
      }, 100)
      // 设置初始化代码
      setTimeout(() => {
        this.$refs.editor.contentWindow.postMessage(
          { msg: 'set_python_code', code: this.currentAnswer }, CONFIG.python
        )
      }, 100)
    },
    // 获取3DBox地址
    async fetch3DBoxInfo() {
      try {
        const info = await get3DBoxInfo({
          type: Enum3DBoxType.Create,
          questionId: this.question.questionId,
          title: `${this.question.questionId}_${this.question.questionName}`
        })
        this.box3dWorkId = info.workId
        return info
      } catch (e) {
        this.$message.error(e.message)
        return { url: '' }
      }
    },

    // 初始化Kitten·N
    async initKittenN() {
      if (this.knIniting) {
        this.$refs.kittenN.innerHTML = ''
      }
      this.knIniting = true
      try {
        // 先销毁，再初始化
        if (this.knSdk) {
          this.$refs.kittenN.innerHTML = ''
          this.knSdk.application.destroy()
          this.knSdk = null
        }
        this.knSdk = await initKittenN({
          container: this.$refs.kittenN
        })
        this.knIniting = false
        this.loadKittenNWork()
      } catch (e) {
        this.knIniting = false
        this.$message.error('Kitten·N加载失败，请刷新页面重试')
        console.error('Kitten·N加载失败', e)
      }
    },

    // 加载作品
    async loadKittenNWork() {
      const { questionType } = this.question
      if (questionType === EnumQuestionType.KittenN) {
        try {
          let work = {
            type: 'courseUrl',
            courseUrl: this.question.cloudOperation.start_work
          }
          if (this.currentAnswer) {
            work = {
              type: 'workId',
              workId: this.currentAnswer.workId
            }
          }
          await this.knSdk.application.loadWork({ work })
        } catch (e) {
          this.$message.error('作品加载失败，请稍后重试！')
        }
      }
    },

    showFullScreen () {
      if (this.question.questionType === 2) {
        this.$refs.editor.style.width = document.body.clientWidth
        this.$refs.editor.style.height = document.body.clientHeight
        setTimeout(() => {
          this.$refs.editor.contentWindow.postMessage(
            { msg: 'set_fullscreen_done',
              is_fullscreen: true }, CONFIG.python
          )
        }, 100)
      }
      this.editorFullScreen = true
    },
    outFullScreen () {
      if (this.question.questionType === 2) {
        setTimeout(() => {
          this.$refs.editor.contentWindow.postMessage(
            { msg: 'set_fullscreen_done',
              is_fullscreen: true }, CONFIG.python
          )
        }, 100)
      }
      this.editorFullScreen = false
      this.showDetail = false
      this.activeTab = 'content'
    },
    async urlEncode () {
      const { questionType, answer, uploadUrl } = this.question
      switch (questionType) {
        case EnumQuestionType.Python:
          this.toolUrl = CONFIG.python
          break
        case EnumQuestionType.Kitten:
          this.toolUrl = `${window.CONFIG.ide}?in_edu_lesson=true`
          break
        case EnumQuestionType.Scratch:
          this.toolUrl = `${window.CONFIG.scratch}?work_url=${answer || uploadUrl}`
          break
        case EnumQuestionType.Cplusplus:
          this.toolUrl = CONFIG.cplusplus
          break
        case EnumQuestionType.PythonOJ:
          this.toolUrl = CONFIG.python_oj
          break
        case EnumQuestionType.CplusplusRealTimeOJ:
          this.toolUrl = CONFIG.cplusplus
          break
        case EnumQuestionType.PythonRealTimeOJ:
          this.toolUrl = CONFIG.python_oj
          break
        case EnumQuestionType.Wood2Cloud:
          this.toolUrl = CONFIG.wood2_cloud
          break
      }
    },
    prevQuestion () {
      this.$emit('prevQuestion', this.question.questionId)
    },
    nextQuestion () {
      this.$emit('nextQuestion', this.question.questionId)
    },
    async handleShowOjRealTimeResult() {
      this.$refs.ojResultModal.open()
      try {
        const serviceResult = await getLastOjRealtimeResult({
          examId: this.$route.query.examId || getExamId(),
          questionId: this.question.questionId
        })
        const resultData = this.processOJResult(serviceResult)
        this.$refs.ojResultModal.showResult(resultData)
      } catch (error) {
        console.error(error)
        this.$refs.ojResultModal.close()
        this.$message.error('获取上一次判题结果失败')
      }
    },
    formatMemory(memory) {
      if (memory < 1000) {
        return `${memory}B`
      } else if (memory < 1000 * 1000) {
        return `${(memory / 1000).toFixed(2)}KB`
      } else if (memory < 1000 * 1000 * 1000) {
        return `${(memory / 1000 / 1000).toFixed(2)}MB`
      } else {
        return `${(memory / 1000 / 1000 / 1000).toFixed(2)}GB`
      }
    },
    // 处理OJ判题结果
    processOJResult(res) {
      const testCases = res.result.map((item) => {
        // 如果output末尾字符为\n，则去掉
        const status = item.pointResult
        return {
          status,
          runtime: item.timeCost + 'ms',
          memory: this.formatMemory(item.memoryCost)
        }
      })

      const passed = res.pass
      const failed = res.notPass

      return {
        total: testCases.length,
        passed,
        failed,
        testCases
      }
    },
    async handleDownloadCode() {
      const { code } = await getLastOjRealtimeCode({
        examId: this.$route.query.examId || getExamId(),
        questionId: this.question.questionId
      })

      const a = document.createElement('a')
      a.href = `data:text/plain;charset=utf-8,${encodeURIComponent(code)}`
      a.download = 'code.txt'
      a.click()
    },
    openQuestionBackgroundModal() {
      this.showQuestionBackground = true
    },
    formateType(id, questionType = 5) {
      return formateQuesType(id, questionType)
    }
  },
  destroyed() {
  }
}
</script>
<style>
.el-image-viewer__mask{
  cursor: pointer;
}
.el-image-viewer__close{
  top: 80px;
  width: 48px;
  height: 48px;
  background: rgba(0, 0, 0, 0.4);
}
.el-icon-circle-close::before{
  content: "\e6db";
  color: #fff;
  font-size: 24px;
  line-height: 48px;
  font-weight: bold;
}
.answer-wrap img {
    max-width: 100%;
}
</style>
<style lang="scss" scoped>
  .question-content {
    height: 100%;
    flex: 1;
    background-color: #fff;
    box-shadow:0 0 20px 0 rgba(0, 0, 0, .1);
    border-radius: 8px 8px 0 0;
    padding: 20px;
    position: relative;
    .scroll-box {
      position: relative;
      height: calc(100% - 53px);
      padding-top: 20px;
      padding-bottom: 82px;
      overflow: scroll;
      &::-webkit-scrollbar {
        width: 10px;
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: #666;
      }
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 10px;
        background: #f7f7f7;
      }
    }
    /deep/ .el-radio__input.is-checked .el-radio__inner {
      background-color: #397EFD;
      border-color: #397EFD;
    }
    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: #397EFD;
    }
    /deep/ .el-radio__input + .el-radio__label {
      color: #333;
      font-weight: 400;
    }
    /deep/ .el-radio__inner:hover {
      border-color: #397EFD;
    }
  }
  .inner-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;
    border-bottom: 1px solid #f2f7ff;
    .type-name {
      font-size: 24px;
      color: #333;
      line-height: 32px;
      .score {
        color: #666;
      }
    }
  }
  .question-desc {
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 27px;
    letter-spacing: .5px;
    max-width: 960px;
    /deep/ img {
      max-width: 100%;
      max-height: 360px;
      width: auto;
      height: auto;
    }
  }
  .blank-wrap {
    position: relative;
    margin-bottom: 30px;
    .blank-fill {
      width: 420px;
      height: 42px;
      border: 1px solid #397EFD;
      border-radius: 4px;
      padding-left: 20px;
      font-size: 16px;
      &::placeholder {
        font-size: 16px;
        color: #bbb;
      }
    }
    .flag {
      position: absolute;
      display: inline-block;
      left: 380px;
      top: 0;
      line-height: 50px;
    }
  }
  .tool-wrap {
    width: 500px;
    height: 333px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    .editor {
      width: 100%;
      height: 100%;
      transition: all 0.4s linear;
      &.full-screen {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 3;
      }
    }
    .full-screen-btn {
      position: fixed;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
      z-index: 3;
      display: flex;
      flex-direction: column;
      button {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.15);
        cursor: pointer;
        transition: background-color .1s ease-in-out;
        padding: 0;
        &:hover {
          background: #397EFD;
          &:after {
            font-size: 14px;
            color: #fff;
            line-height: 20px;
            padding: 10px 16px;
            display: inline-block;
            width: 60px;
            height: 60px;
            box-sizing: border-box;
            border-radius: 50%;
          }
        }
      }
              .title-tip {
        background: #397EFD url('./title_tip@2x.png') no-repeat center / 27px 33px;
        margin-bottom: 15px;
        position: relative;
        &:hover {
          &:after {
            content: '查看题目';
          }
        }
        .tip {
          visibility: hidden;
          position: absolute;
          right: 70px;
          top: 50%;
          transform: translateY(-50%);
          width: 600px;
          height: 400px;
          background-color: #fff;
          border-radius: 8px;
          box-shadow:0 8px 16px 0 rgba(0, 0, 0, .1);
          padding: 20px;
          text-align: left;
          opacity: 0;
          transition: opacity .1s linear;
          &.show {
            visibility: visible;
            opacity: 1;
            z-index: 99;
          }
        }
        .icon-close {
          display: none;
          width: 16px;
          height: 16px;
          background: url('~@/assets/images/icon-black-close.png') center / cover no-repeat;
          float: right;
          cursor: pointer;
          position: relative;
          z-index: 1;
        }
      }
      .out-full-screen {
        background: #fff url('./full_screen@2x.png') no-repeat center / 30px;
        &:hover {
          &:after {
            font-size: 13px;
            content: '退出全屏';
          }
        }
      }
    }
    .mask {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, .5);
    }
    .toAnswer {
      width: 100%;
      line-height: 33px;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 24px;
      font-weight: 300;
      cursor: pointer;
      .arrow {
        background: url('./full_screen_arrow@2x.png') no-repeat center / cover;
        width: 23px;
        height: 18px;
        margin-left: 10px;
      }
    }
  }
  .new-type-wrap  {
    .upload-wrap {
      width: 100%;
      padding: 30px 0 30px 13px;
      color: #111;
      font-size: 16px;
      background-color: #FAFAFA;
      .tip {
        margin-bottom: 20px;
      }
      .answer-wrap {
        padding: 5px 0 0 75px;
        height: 55px;
        position: relative;
        display: flex;
        .python-icon {
          position: absolute;
          top: 0;
          left: 0;
          width: 55px;
          height: 55px;
          background: url('~images/python-icon.png') center / cover no-repeat;
        }
        .answer-info {
          width: 256px;
          color: #333;
          font-size: 16px;
          line-height: 25px;
          .file-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .upload-time {
            color: #999;
            font-size: 14px;
          }
        }
        .change-btn {
          line-height: 25px;
          font-size: 16px;
          color: #377DFD;
          cursor: pointer;
          margin-left: 20px;
        }
      }
    }
    .data-upload, .data-download {
      display: flex;
      align-items: center;
      height: 42px;
      padding: 0 30px;
      border: 1px solid #397EFD;
      border-radius: 4px;
      color: #397EFD;
      font-size: 16px;
      line-height: 22px;
      cursor: pointer;
      background-color: #fff;
      .download-icon, .upload-icon {
        display: inline-block;
        width: 19px;
        height: 18px;
        background: url('~images/nct-download.png') no-repeat center / cover;
        margin-right: 9px;
      }
      .upload-icon {
        background: url('~images/nct-upload.png') no-repeat center / cover;
      }
    }
    .data-download {
      margin: 0 0 25px 13px;
    }
  }
  .option-wrap {
    display: inline-block;
    .option {
      display: flex;
      border-radius: 8px;
      border: 1px solid #efefef;
      margin-bottom: 20px;
      overflow: hidden;
      padding-right: 15px;
      min-width: 480px;
      max-width: 70%;
      .option-name-wrap {
        flex: 0 0 35px;
        background-color: #F5F9FF;
        margin-right: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px 0 0 5px;
      }
      .option-content {
        display: flex;
        flex-direction: column;
        padding: 18px 0;
        // width: 454px;
        .desc {
          width: 100%;
        }
        .image {
          max-width: 100%;
          display: block;
          border-radius: 4px;
        }
      }
    }
    .no-answer {
      align-self: center;
      position: absolute;
      left: 530px;
      margin-left: 0;
    }
  }
  .no-answer {
    width: 50px;
    font-size: 12px;
    color: #FF4E4E;
    margin-left: 20px;
  }
  .btn-wrap {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 82px;
    width: 100%;
    background: rgba(255, 255, 255, .9);
    display: flex;
    padding: 0 20px;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #F2F7FF;
    z-index: 2;
    a {
      display: inline-block;
      width: 160px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      border-radius: 4px;
      background: #fff;
    }
    .prev-btn {
      color: #397EFD;
      border: 1px solid rgba(57,126,253,1);
      margin-right: 30px;
    }
    .next-btn {
      background-color: #397EFD;
      border-color: #397EFD;
      color: #fff;
      &:hover {
        opacity: .8;
      }
    }
  }
  .answer-wrap {
    font-size: 14px;
    color: #FF9743;
    margin-top: 20px;
    /deep/ .image-wrap img {
      max-width: 465px;
    }
  }
  .link-color {
    color: #397EFD;
  }
  .is-correct-input {
    border: 2px solid #00C882 !important;
    color: #00C882;
    &.option .option-name-wrap {
      background-color: #00C882;
      color: #fff;
    }
  }
  .is-error-input {
    border: 2px solid #FF4E4E !important;
    background: rgba(255, 78, 78, .1);
    color: #FF4E4E;
    &.option .option-name-wrap {
      background-color: #FF4E4E;
      color: #fff;
    }
  }
  .flag {
    align-self: center;
    margin-left: 10px;
    i {
      display: inline-block;
    }
    .icon-correct {
      width: 17px;
      height: 12px;
      background: url("./icon-correct.png") center / cover no-repeat;
    }
    .icon-error {
      width: 14px;
      height: 14px;
      background: url("./icon-error.png") center / cover no-repeat;
    }
  }
/deep/ .el-tabs__content {
  height: calc(100% - 40px);
  overflow: auto;
}
.full-screen-btn {
  .tip.show .icon-close {
    display: inline-block;
  }
}
.submit-oj-btn {
  color: #fff;
  background: #f8d458;
  margin-bottom: 15px;
}
</style>
